import type { ReactNode } from 'react'
import { ApiError } from '../lib/api'

/**
 * 로딩·실패·빈 상태를 한 자리에서 표현한다.
 * 실패를 빈 목록으로 보여주지 않는 게 목적이다 — "카드가 없다"와 "못 불러왔다"는 다른 사실이다.
 */
export function QueryState(props: {
  isPending: boolean
  error: unknown
  isEmpty?: boolean
  emptyMessage?: string
  children: ReactNode
}) {
  if (props.isPending) return <p className="muted small">불러오는 중…</p>

  if (props.error) {
    const msg =
      props.error instanceof ApiError
        ? (props.error.detail[0] ?? props.error.code)
        : '알 수 없는 오류가 발생했습니다.'
    return (
      <div className="notice error">
        <b>불러오지 못했습니다.</b> {msg}
      </div>
    )
  }

  if (props.isEmpty) {
    return <p className="muted small">{props.emptyMessage ?? '표시할 항목이 없습니다.'}</p>
  }

  return <>{props.children}</>
}
